import React from 'react';
import { useParams } from 'react-router-dom';
import BasePage from './BasePage';
import Loading from '../../components/Loading';

const skillInfo = {
  'html': { title: 'HTML', description: 'マークアップ言語', image: '/images/siteHtml.png' },
  'css': { title: 'CSS', description: 'スタイルシート言語', image: '/images/siteCss.png' },
  'javascript': { title: 'JavaScript', description: 'プログラミング言語', image: '/images/siteJavascript.png' },
  'react': { title: 'React', description: 'JavaScriptライブラリ', image: '/images/React-icon.svg.png' },
  'tailwind': { title: 'Tailwind', description: 'CSSフレームワーク', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-plain.svg' },
  'python': { title: 'Python', description: 'プログラミング言語', image: '/images/sitePython.png' },
  'c': { title: 'C', description: 'プログラミング言語', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg' },
  'sql': { title: 'SQL', description: 'データベース言語', image: '/images/siteSql.png' },
  'nextjs': { title: 'Next.js', description: 'Reactフレームワーク', image: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg' }
};

const PageGenerator = () => {
  const { language } = useParams();
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const loadData = async () => {
      if (!skillInfo[language]) {
        setLoading(false);
        return;
      }

      await new Promise(resolve => setTimeout(resolve, 2000));
      setLoading(false);
    };

    loadData();
  }, [language]);

  if (loading) {
    return <Loading />;
  }

  const skill = skillInfo[language];
  if (!skill) {
    return <div>Language "{language}" not found</div>;
  }

  return <BasePage skill={skill} data={[]} />;
};

export default PageGenerator;
